import { render } from "./MatchinPayReload.vue?vue&type=template&id=27da6109&ts=true"
import script from "./MatchinPayReload.vue?vue&type=script&lang=ts"
export * from "./MatchinPayReload.vue?vue&type=script&lang=ts"

import "./MatchinPayReload.vue?vue&type=style&index=0&id=27da6109&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__